import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment.defaults";

import { AuthService } from "../services/auth.service";

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
	constructor(private readonly authService: AuthService) {}
	private readonly bboExtVersionKeyInHeader = "bboExtVersion";
	intercept(req: HttpRequest<unknown>, next: HttpHandler) {
		const request = req.clone({
			headers: req.headers.append(this.bboExtVersionKeyInHeader, environment.version),
		});

		return next.handle(request).pipe(
			tap((response) => {
				if (
					response instanceof HttpResponse &&
					response.status == HttpStatusCode.ResetContent &&
					response.headers.get(this.bboExtVersionKeyInHeader) &&
					response.headers.get(this.bboExtVersionKeyInHeader) != environment.version
				) {
					this.authService.logout(true);
				}
			}),
		);
	}
}
